import ColorGame from './color';

export default ColorGame;
